/**
 * Shared TanStack Query retry configuration
 * - 1 retry maximum
 * - No retries for 4XX client errors
 */

/**
 * Default retry function that skips 4XX errors and allows only 1 retry for other errors
 * @param failureCount - The number of times the query has failed
 * @param error - The error object from the failed request
 * @returns boolean indicating whether to retry
 */
export const defaultRetryFunction = (failureCount: number, error: unknown): boolean => {
  // Don't retry if it's a 4XX error
  if (error && typeof error === 'object' && 'status' in error) {
    const status = (error as { status: number }).status;
    if (status >= 400 && status < 500) {
      return false;
    }
  }

  // Check if error has a response property (ky error structure)
  if (error && typeof error === 'object' && 'response' in error) {
    const response = (error as { response: { status: number } }).response;
    if (response && typeof response === 'object' && 'status' in response) {
      const status = response.status;
      if (status >= 400 && status < 500) {
        return false;
      }
    }
  }

  // Otherwise, retry once
  return failureCount < 1;
};
